import { gql } from '@apollo/client'

import { PROJECT_BASE_GQL_SCHEMA, PROJECT_SETTINGS_GQL_SCHEMA } from '@/requests/apollo/schema.ts'
import { useQuery } from '@apollo/client/react/hooks/useQuery'

export const useQueryProjects = () => {
  const { data, loading, error, refetch } = useQuery(
    gql`query GetProjects {
      projects {
        ${PROJECT_BASE_GQL_SCHEMA}
        ${PROJECT_SETTINGS_GQL_SCHEMA}
      }
    }`,
  )

  return {
    projectsMeta: data?.projects || [],
    loading,
    error,
    refetch,
  }
}
